import { ReactComponent as CloseIcon } from "assets/close-small.svg";
import AttachmentsGallery from "components/AttachmentsGallery";
import { IAttachment } from "interfaces/Attachments";

import * as S from "./styles";

type PicturesModalProps = {
  isOpen: boolean;
  onCloseButtonClick: () => void;
  gallery: IAttachment[];
};

export default function PicturesModal({
  isOpen,
  gallery,
  onCloseButtonClick,
}: PicturesModalProps) {
  if (!isOpen) return null;

  return (
    <S.Overlay>
      <S.ModalContainer>
        <S.StyledCloseIcon onClick={onCloseButtonClick} />

        {(!gallery || gallery.length === 0) && (
          <h1>Essa ocorrência não possui anexos.</h1>
        )}

        {gallery.length > 0 && (
          <AttachmentsGallery
            photoGallery={gallery}
          />
        )}
      </S.ModalContainer>
    </S.Overlay>
  );
}
